window.VH = window.VH === undefined ? {} : window.VH;
VH.AjaxModal = {
    initMultyModal : function initMultyModal() {
        $(document).on('show.bs.modal', '.modal', function () {
            var zIndex = 1040 + (10 * $('.modal:visible').length);
            $(this).css('z-index', zIndex);
            setTimeout(function () {
                $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
            }, 0);
        });

        $(document).on('hidden.bs.modal', '.modal', function () {
            $('.modal:visible').length && $(document.body).addClass('modal-open');
        });
    },

    init : function init(modalSelector, triggerSelector) {
        let _t = VH.AjaxModal,
            mSelector = modalSelector === undefined ? '#ajaxModal' : modalSelector,
            tSelector = triggerSelector === undefined ? '.ajaxModal' : triggerSelector,
            modal = $(mSelector);

        _t.initMultyModal();

        VH.Helper.b.on('click', tSelector + ' a', VH.Helper.onInModalAClick);

        VH.Helper.b.on('click', tSelector, function (event) {
            let t = $(this),
                url = t.attr('href'),
                type = t.data('ajax-modal-type')
            ;

            type = type === undefined ? 'default' : type;

            $('.modal-header h4', modal).html(t.data('ajax-modal-title'));
            VH.TomSelect.init();
            if (url === '#') {
                // console.log([modal]);
                modal.modal('show');
            } else {
                let h = VH.Helper.w.height() * .85;
                // console.log([h]);
                switch (type) {
                    case 'image':
                        let img = $('<img>')
                            .attr({
                                src:url,
                                class: 'img img-response',
                                style:'max-height:' + h + 'px; max-width: 100%;'
                            }),
                            div = $('<div class="text-center">').append(img);

                        $('.modal-body', modal).html('');
                        $('.modal-body', modal).append(div);
                        modal.modal('show');
                        break;
                    case 'pdf':
                        let content = $('<iframe>')
                            .attr({
                                src:url,
                                style:'height:' + h + 'px;width:100%;border:none;'
                            });

                        $('.modal-body', modal).html('');
                        $('.modal-body', modal).append(content);
                        modal.modal('show');
                        break;
                    case 'file':
                        return true;
                    case 'carousel':
                        $.get(url, function (data) {
                            $('.modal-body', modal).html(data);
                            $('.modal-body', modal).attr({
                                style:'height:' + h + 'px;width:100%;'
                            });
                            modal.modal('show');
                        });
                        break;
                    default:
                        $.get(url, function (data) {
                            $('.modal-body', modal).html(data);
                            modal.on('shown.bs.modal', function () {
                                VH.AjaxLoadContent.init();
                            });
                            modal.modal('show');
                        });
                        break;
                }
            }
            event.stopImmediatePropagation();
            return false;
        });
    }
};